import { useEffect } from 'react'

import { useDetachedAppLoadStateStore } from './detachedAppLoadState'

type ReportDetachedAppLoadStateArgs = {
  appId: string
  isLoaded: boolean
  isError: boolean
  missingRemoteUrl: boolean
}

export const useReportDetachedAppLoadState = ({
  appId,
  isLoaded,
  isError,
  missingRemoteUrl
}: ReportDetachedAppLoadStateArgs): void => {
  const setLoadState = useDetachedAppLoadStateStore(s => s.setLoadState)
  const resetLoadState = useDetachedAppLoadStateStore(s => s.resetLoadState)

  useEffect(() => {
    setLoadState(appId, 'loading')

    return () => {
      resetLoadState()
    }
  }, [appId, resetLoadState, setLoadState])

  useEffect(() => {
    if (missingRemoteUrl || isError) {
      setLoadState(appId, 'error')
      return
    }

    if (isLoaded) {
      setLoadState(appId, 'ready')
    }
  }, [appId, isError, isLoaded, missingRemoteUrl, setLoadState])
}
